import styled from "styled-components";

export const FooterButtons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.displayErrors ? "space-between" : "end"};
`;
